import { render, staticRenderFns } from "./CreateUpdateDomainForm.vue?vue&type=template&id=c4da767c&scoped=true&"
import script from "./CreateUpdateDomainForm.vue?vue&type=script&lang=ts&"
export * from "./CreateUpdateDomainForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateUpdateDomainForm.vue?vue&type=style&index=0&id=c4da767c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4da767c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VList,VListItem,VListItemAction,VListItemContent,VRow,VStepperContent,VTextField})
